module.exports = __webpack_public_path__ + "img/x13.1f8a16fe.jpg";